import { loadMemos, MEMOS_KEY } from '@nexus/workspace';
import { useStoreQuery } from '../db/context';

export function useMemos() {
  return useStoreQuery((s) => loadMemos(s), [], ['pages', 'props', 'settings']);
}

/** Id of the hidden "Onthouden" folder, if any (it opens as the Onthouden view). */
export function useMemosFolderId(): string | null {
  return useStoreQuery((s) => s.getSetting(MEMOS_KEY), [], ['settings']) ?? null;
}
